// Containers provide runtime values; local development retains CRA .env support.
const runtimeConfig = window.ENV || {
  REACT_APP_GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  REACT_APP_ANTHROPOD_API_URL: process.env.REACT_APP_ANTHROPOD_API_URL,
  REACT_APP_ANTHROPOD_DASHBOARD_URL: process.env.REACT_APP_ANTHROPOD_DASHBOARD_URL,
  REACT_APP_MICROSOFT_CLIENT_ID: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
  REACT_APP_MICROSOFT_REDIRECT_URI: process.env.REACT_APP_MICROSOFT_REDIRECT_URI,
  REACT_APP_AGENT_WIDGET_SCRIPT_URL: process.env.REACT_APP_AGENT_WIDGET_SCRIPT_URL,
};

export default runtimeConfig;
